type TokenGetter = (options?: { skipCache?: boolean }) => Promise<string | null>;

let getter: TokenGetter | null = null;
let signalReady: () => void;
const ready = new Promise<void>((resolve) => {
  signalReady = resolve;
});

/**
 * Bridges Clerk's React-only `getToken` to the axios interceptors, which run outside
 * React and cannot use hooks.
 *
 * Installed by `<ClerkTokenBridge>` (task B5).
 */
export function setTokenGetter(fn: TokenGetter | null) {
  getter = fn;
  if (fn) signalReady();
}

/**
 * Resolves the current session token.
 *
 * The `await ready` is the non-obvious part and it is load-bearing: without it the very
 * first query can fire before Clerk finishes loading, go out with no Authorization
 * header, and 401. That failure is intermittent and race-dependent -- it shows up on a
 * cold load or a slow network and never on the developer's machine.
 */
export async function getAuthToken(options?: { skipCache?: boolean }): Promise<string | null> {
  await ready;
  return getter ? getter(options) : null;
}

/** Test seam. */
export function resetTokenBridgeForTests() {
  getter = null;
}
